// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"23444c8c","247":"c6eeeef6","508":"ff7607b2","534":"d46e8730","710":"ac7e2c00"}[chunkId] + ".chunk.js";
};